import React, { Component } from 'react';
// import TaskView from './TaskView';
import { Text } from '../extensions/LangaugeContainer';

export default class Sicherungskopie extends Component{

  render(){
    return <div>
      {/* <TaskView /> */}
      <Text tid="backup"/>
      </div>
  }
}